<template>
  <ProjectTimeReportsForm :layout="'preview'"></ProjectTimeReportsForm>
</template>

<script type="text/javascript">
  import ProjectTimeReportsForm from "../components/ProjectTimeReportsForm/ProjectTimeReportsForm";
  export default {
    name: "TimesReportPreview",
    components: {ProjectTimeReportsForm}
  }
</script>